import { usePlansForCompare as usePlans } from '@coverright/features';
import { useAppContext } from '@coverright/shared/contexts';
import { useMedicareQuote } from './medicare/use-medicare-quote';

export function usePlansForCompare() {
  const quote = useMedicareQuote();
  const appContext = useAppContext();
  return usePlans(appContext, quote?.id, quote?.clientId);
}
